// Part of purchasePages, split by screen to keep files short; purchasePages.ts merges the parts.
export const en = {
  bankForms: {
    chooseFrom: 'Choose the account the money leaves',
    chooseTo: 'Choose the account the money goes to',
    chooseDifferent: 'Choose a different account',
    amountAboveZero: 'Enter an amount above zero',
    amountReceivedIn: 'Enter the amount received in {{currency}}',
    enterDate: 'Enter the date',
    enterRuleName: 'Enter a rule name',
    atMostChars: 'Use at most {{max}} characters',
    enterValue: 'Enter a value',
    amountExample: 'Enter an amount such as 250 or 99.50',
    chooseCategory: 'Choose a category',
    codeWrongDirection: 'This code does not fit the direction; choose another',
    enterEndBalance: 'Enter the statement ending balance',
    enterEndDate: 'Enter the statement ending date',
    endDateAfterLast: 'The ending date must be after the last reconciliation',
  },
  bankLabels: {
    csvField: {
      date: 'Date',
      description: 'Description',
      payee: 'Payee',
      reference: 'Reference',
      amount: 'Amount',
      moneyIn: 'Money in',
      moneyOut: 'Money out',
      balance: 'Balance',
    },
    taxWord: { vat: 'VAT', gst: 'GST' },
    noTax: 'No {{tax}}',
    moneyIn: 'Money in',
    moneyOut: 'Money out',
    moneyInOrOut: 'Money in or out',
    allBankAccounts: 'All bank accounts',
    view: 'View',
    add: 'Add',
    adding: 'Adding…',
    match: 'Match',
    transfer: 'Transfer',
    categorise: 'Categorise',
    exclude: 'Exclude',
    undo: 'Undo',
    delete: 'Delete',
    payee: 'Payee',
    memo: 'Memo',
    category: 'Category',
    categoryRequired: 'Category *',
  },
  bankFeed: {
    title: 'Bank transactions',
    more: 'More',
    manageRules: 'Manage rules',
    reconcile: 'Reconcile',
    recordTransfer: 'Record a transfer',
    goToRegister: 'Go to bank register',
    importStatement: 'Import statement',
    selectClientHint: 'Use the client switcher in the top bar.',
    loadAccountsFailed: 'Could not load bank accounts',
    noAccounts: 'No bank accounts yet',
    noAccountsHint:
      'Add a Bank or Credit card account to the chart of accounts, then import its statement.',
    chartOfAccounts: 'Chart of accounts',
    tabsAria: 'Bank transaction tabs',
    tab: { for_review: 'For review', categorised: 'Categorised', excluded: 'Excluded' },
    forReviewCount: 'For review ({{count}})',
    accountsAria: 'Bank accounts',
    bankBalance: 'Bank balance',
    inOutss: 'In Outss Accounting',
    inCurrency: 'In {{currency}}',
    toReview: '{{count}} to review',
    imported: 'Imported {{date}}',
    noStatement: 'No statement yet',
    searchAria: 'Search bank transactions',
    searchPlaceholder: 'Search by description, payee or amount',
    selectedCount: '{{count}} selected',
    accept: 'Accept',
    rules: 'Rules',
    loadLinesFailed: 'Could not load transactions',
    noSearchMatch: 'No transactions match your search',
    nothingToReview: 'Nothing to review',
    noCategorised: 'No categorised transactions yet',
    noExcluded: 'No excluded transactions',
    importHint: 'Import a statement to bring in new bank transactions.',
    selectAll: 'Select all',
    selectLine: 'Select {{description}}',
    col: {
      date: 'Date',
      description: 'Description',
      payee: 'Payee',
      categoryOrMatch: 'Category or match',
      addedOrMatched: 'Added or matched to',
      reason: 'Reason',
      spent: 'Spent',
      received: 'Received',
      action: 'Action',
    },
    batchDone: {
      accept_one: 'Accepted {{count}} transaction',
      accept_other: 'Accepted {{count}} transactions',
      exclude_one: 'Excluded {{count}} transaction',
      exclude_other: 'Excluded {{count}} transactions',
      undo_one: 'Undone {{count}} transaction',
      undo_other: 'Undone {{count}} transactions',
    },
    batchSkipped: {
      accept: '; {{count}} had nothing to accept',
      exclude: '; {{count}} had nothing to exclude',
      undo: '; {{count}} had nothing to undo',
    },
    batchFailed: '; {{count}} failed: {{message}}',
    batchEnd: '.',
    autoAddedTitle: 'Added automatically by a rule',
    acceptedFromRule: 'Accepted from a rule',
    autoAddedRule: 'Auto-added: {{rule}}',
    ruleBadge: 'Rule: {{rule}}',
    reconciled: 'Reconciled',
    excluded: 'Excluded',
    uncategorised: 'Uncategorised',
    oneMatch: '1 match found',
    transferTo: 'Transfer: {{account}}',
    ai: 'AI',
    reconciledUndoFirst: 'Reconciled. Undo the reconciliation first.',
  },
  lineEditor: {
    mode: { categorise: 'Categorise', match: 'Find match', transfer: 'Record as transfer' },
    ref: 'Ref {{ref}}',
    addedTo: 'Added to {{label}}.',
    addedToBooks: 'Added to the books.',
    excludedToast: 'Excluded. Find it under Excluded to undo.',
    filledByRule: 'Filled in by the rule',
    payer: 'Payer',
    chooseName: 'Choose a name',
    chooseCategory: 'Choose a category',
    categoryLine: 'Category, line {{n}}',
    descriptionLine: 'Description, line {{n}}',
    amountLine: 'Amount, line {{n}}',
    vatLine: 'VAT, line {{n}}',
    deleteLine: 'Delete line {{n}}',
    colDescription: 'Description',
    colAmount: 'Amount',
    addLine: 'Add line',
    enterSplitAmounts: 'Enter an amount on every split line.',
    splitBalanced: 'The split lines add up to the bank amount.',
    splitDifference: 'Difference: {{amount}}',
    removeSplit: 'Remove split',
    split: 'Split',
    matched: 'Matched. Nothing new was posted.',
    badRange: 'The From date must be on or before the To date.',
    from: 'From',
    to: 'To',
    searchAria: 'Search by name, memo, number or amount',
    searchPlaceholder: 'Name, memo, no. or amount',
    colDate: 'Date',
    colType: 'Type',
    colRef: 'Ref no.',
    noCandidates:
      'No transactions to match in these dates. Widen the dates, or categorise the line instead.',
    selectCandidate: 'Select {{type}} {{ref}}',
    bankLineAmount: 'Bank line {{currency}} {{amount}}',
    selectedAmount: 'Selected {{currency}} {{amount}}',
    matchDifference: 'Difference {{amount}}',
    matching: 'Matching…',
    recordedTransfer: 'Recorded as a transfer.',
    transferredFrom: 'Transferred from *',
    transferredTo: 'Transferred to *',
    chooseOther: 'Choose the other account',
    chooseAccount: 'Choose an account',
    amountIn: 'Amount in {{currency}} *',
    enterAmountIn: 'Enter the amount in {{currency}}',
    otherStatementHint:
      "When the other account's statement is imported, its line matches this transfer.",
  },
  ruleDrawer: {
    textOp: {
      contains: 'contains',
      not_contains: "doesn't contain",
      equals: 'is exactly',
      starts_with: 'starts with',
    },
    amountOp: { equals: 'equals', greater_than: 'is greater than', less_than: 'is less than' },
    saved: 'Rule "{{name}}" saved.',
    savedApplies_one: 'Rule "{{name}}" saved. It applies to {{count}} transaction in For review.',
    savedApplies_other:
      'Rule "{{name}}" saved. It applies to {{count}} transactions in For review.',
    editTitle: 'Edit rule',
    newTitle: 'New rule',
    description:
      'Rules categorise bank transactions the same way every time. The first rule that applies wins, in the order shown on the Rules page.',
    ruleName: 'Rule name *',
    applyTo: 'Apply this to transactions that are',
    inAccount: 'In',
    includeBefore: 'and include',
    includeAfter: 'of the following',
    matchAria: 'All or any conditions',
    all: 'all',
    any: 'any',
    conditionField: 'Condition {{n}} field',
    conditionOperator: 'Condition {{n}} operator',
    conditionValue: 'Condition {{n}} value',
    bankText: 'Bank text',
    amount: 'Amount',
    valuePlaceholder: 'e.g. DEWA',
    removeCondition: 'Remove condition {{n}}',
    addCondition: 'Add a condition',
    then: 'Then',
    assignCategory: 'Assign a category',
    autoAdd: 'Automatically confirm transactions this rule applies to (auto-add)',
    autoAddHint:
      'New transactions from the next import skip For review and go straight to Categorised, marked with the rule. A transaction that matches one already in the books is left for you to match instead.',
    rule: 'Rule',
  },
  rules: {
    title: 'Rules',
    description:
      'Rules categorise bank transactions for you. The first rule that applies wins, from the top.',
    newRule: 'New rule',
    loadFailed: 'Could not load rules',
    noRules: 'No rules yet',
    noRulesHint:
      'Create a rule for transactions that come up every month, such as DEWA, du or bank charges.',
    col: {
      priority: 'Priority',
      ruleName: 'Rule name',
      appliedTo: 'Applied to',
      conditions: 'Conditions',
      settings: 'Settings',
      inForReview: 'In For review',
      action: 'Action',
    },
    moveUp: 'Move {{name}} up',
    moveDown: 'Move {{name}} down',
    autoAdd: 'Auto-add',
    vatCode: 'VAT {{code}}',
    deleted: 'Rule "{{name}}" deleted.',
    deleteTitle: 'Delete the rule “{{name}}”?',
    deleteBody:
      'Transactions it already categorised stay as they are. It stops suggesting categories for transactions in For review.',
    condText: {
      contains: 'Bank text contains “{{value}}”',
      not_contains: "Bank text doesn't contain “{{value}}”",
      equals: 'Bank text is “{{value}}”',
      starts_with: 'Bank text starts with “{{value}}”',
      greater_than: 'Bank text is greater than “{{value}}”',
      less_than: 'Bank text is less than “{{value}}”',
    },
    condAmount: {
      contains: 'Amount contains {{value}}',
      not_contains: "Amount doesn't contain {{value}}",
      equals: 'Amount is {{value}}',
      starts_with: 'Amount starts with {{value}}',
      greater_than: 'Amount is greater than {{value}}',
      less_than: 'Amount is less than {{value}}',
    },
    joinAnd: ' and ',
    joinOr: ' or ',
  },
};

export const ar = {
  bankForms: {
    chooseFrom: 'اختر الحساب الذي تخرج منه الأموال',
    chooseTo: 'اختر الحساب الذي تذهب إليه الأموال',
    chooseDifferent: 'اختر حساباً مختلفاً',
    amountAboveZero: 'أدخل مبلغاً أكبر من الصفر',
    amountReceivedIn: 'أدخل المبلغ المستلم بعملة {{currency}}',
    enterDate: 'أدخل التاريخ',
    enterRuleName: 'أدخل اسم القاعدة',
    atMostChars: 'استخدم {{max}} حرفاً كحد أقصى',
    enterValue: 'أدخل قيمة',
    amountExample: 'أدخل مبلغاً مثل 250 أو 99.50',
    chooseCategory: 'اختر فئة',
    codeWrongDirection: 'هذا الرمز لا يناسب اتجاه المعاملة؛ اختر رمزاً آخر',
    enterEndBalance: 'أدخل الرصيد الختامي في الكشف',
    enterEndDate: 'أدخل تاريخ نهاية الكشف',
    endDateAfterLast: 'يجب أن يكون تاريخ النهاية بعد آخر تسوية بنكية',
  },
  bankLabels: {
    csvField: {
      date: 'التاريخ',
      description: 'الوصف',
      payee: 'المستفيد',
      reference: 'المرجع',
      amount: 'المبلغ',
      moneyIn: 'الوارد',
      moneyOut: 'الصادر',
      balance: 'الرصيد',
    },
    taxWord: { vat: 'ضريبة القيمة المضافة', gst: 'ضريبة السلع والخدمات' },
    noTax: 'بدون {{tax}}',
    moneyIn: 'أموال واردة',
    moneyOut: 'أموال صادرة',
    moneyInOrOut: 'أموال واردة أو صادرة',
    allBankAccounts: 'جميع الحسابات البنكية',
    view: 'عرض',
    add: 'إضافة',
    adding: 'جارٍ الإضافة…',
    match: 'مطابقة',
    transfer: 'تحويل',
    categorise: 'تصنيف',
    exclude: 'استبعاد',
    undo: 'تراجع',
    delete: 'حذف',
    payee: 'المستفيد',
    memo: 'المذكرة',
    category: 'الفئة',
    categoryRequired: 'الفئة *',
  },
  bankFeed: {
    title: 'المعاملات البنكية',
    more: 'المزيد',
    manageRules: 'إدارة القواعد',
    reconcile: 'التسوية البنكية',
    recordTransfer: 'تسجيل تحويل',
    goToRegister: 'الانتقال إلى سجل البنك',
    importStatement: 'استيراد كشف حساب',
    selectClientHint: 'استخدم أداة تبديل العميل في الشريط العلوي.',
    loadAccountsFailed: 'تعذّر تحميل الحسابات البنكية',
    noAccounts: 'لا توجد حسابات بنكية بعد',
    noAccountsHint: 'أضف حساباً بنكياً أو حساب بطاقة ائتمان إلى دليل الحسابات، ثم استورد كشفه.',
    chartOfAccounts: 'دليل الحسابات',
    tabsAria: 'تبويبات المعاملات البنكية',
    tab: { for_review: 'قيد المراجعة', categorised: 'مصنّفة', excluded: 'مستبعدة' },
    forReviewCount: 'قيد المراجعة ({{count}})',
    accountsAria: 'الحسابات البنكية',
    bankBalance: 'رصيد البنك',
    inOutss: 'في Outss Accounting',
    inCurrency: 'بعملة {{currency}}',
    toReview: '{{count}} للمراجعة',
    imported: 'استُورد في {{date}}',
    noStatement: 'لا يوجد كشف بعد',
    searchAria: 'البحث في المعاملات البنكية',
    searchPlaceholder: 'ابحث بالوصف أو المستفيد أو المبلغ',
    selectedCount: 'المحدد: {{count}}',
    accept: 'قبول',
    rules: 'القواعد',
    loadLinesFailed: 'تعذّر تحميل المعاملات',
    noSearchMatch: 'لا توجد معاملات تطابق بحثك',
    nothingToReview: 'لا شيء للمراجعة',
    noCategorised: 'لا توجد معاملات مصنّفة بعد',
    noExcluded: 'لا توجد معاملات مستبعدة',
    importHint: 'استورد كشف حساب لجلب معاملات بنكية جديدة.',
    selectAll: 'تحديد الكل',
    selectLine: 'تحديد {{description}}',
    col: {
      date: 'التاريخ',
      description: 'الوصف',
      payee: 'المستفيد',
      categoryOrMatch: 'الفئة أو المطابقة',
      addedOrMatched: 'أضيفت إلى أو طوبقت مع',
      reason: 'السبب',
      spent: 'المصروف',
      received: 'المقبوض',
      action: 'الإجراء',
    },
    batchDone: {
      accept_zero: 'لم تُقبل أي معاملة',
      accept_one: 'قُبلت معاملة واحدة',
      accept_two: 'قُبلت معاملتان',
      accept_few: 'قُبلت {{count}} معاملات',
      accept_many: 'قُبلت {{count}} معاملةً',
      accept_other: 'قُبلت {{count}} معاملة',
      exclude_zero: 'لم تُستبعد أي معاملة',
      exclude_one: 'استُبعدت معاملة واحدة',
      exclude_two: 'استُبعدت معاملتان',
      exclude_few: 'استُبعدت {{count}} معاملات',
      exclude_many: 'استُبعدت {{count}} معاملةً',
      exclude_other: 'استُبعدت {{count}} معاملة',
      undo_zero: 'لم يُتراجع عن أي معاملة',
      undo_one: 'تم التراجع عن معاملة واحدة',
      undo_two: 'تم التراجع عن معاملتين',
      undo_few: 'تم التراجع عن {{count}} معاملات',
      undo_many: 'تم التراجع عن {{count}} معاملةً',
      undo_other: 'تم التراجع عن {{count}} معاملة',
    },
    batchSkipped: {
      accept: '؛ و{{count}} لم يكن فيها ما يُقبل',
      exclude: '؛ و{{count}} لم يكن فيها ما يُستبعد',
      undo: '؛ و{{count}} لم يكن فيها ما يُتراجع عنه',
    },
    batchFailed: '؛ وتعذّر تنفيذ {{count}}: {{message}}',
    batchEnd: '.',
    autoAddedTitle: 'أضافتها قاعدة تلقائياً',
    acceptedFromRule: 'قُبلت من قاعدة',
    autoAddedRule: 'أضيفت تلقائياً: {{rule}}',
    ruleBadge: 'قاعدة: {{rule}}',
    reconciled: 'تمت تسويتها',
    excluded: 'مستبعدة',
    uncategorised: 'غير مصنّفة',
    oneMatch: 'وُجدت مطابقة واحدة',
    transferTo: 'تحويل: {{account}}',
    ai: 'ذكاء اصطناعي',
    reconciledUndoFirst: 'تمت تسويتها. تراجع عن التسوية البنكية أولاً.',
  },
  lineEditor: {
    mode: { categorise: 'تصنيف', match: 'البحث عن مطابقة', transfer: 'تسجيل كتحويل' },
    ref: 'المرجع {{ref}}',
    addedTo: 'أضيفت إلى {{label}}.',
    addedToBooks: 'أضيفت إلى الدفاتر.',
    excludedToast: 'استُبعدت. تجدها في تبويب «مستبعدة» إن أردت التراجع.',
    filledByRule: 'عُبّئت بواسطة القاعدة',
    payer: 'الدافع',
    chooseName: 'اختر اسماً',
    chooseCategory: 'اختر فئة',
    categoryLine: 'الفئة، السطر {{n}}',
    descriptionLine: 'الوصف، السطر {{n}}',
    amountLine: 'المبلغ، السطر {{n}}',
    vatLine: 'ضريبة القيمة المضافة، السطر {{n}}',
    deleteLine: 'حذف السطر {{n}}',
    colDescription: 'الوصف',
    colAmount: 'المبلغ',
    addLine: 'إضافة سطر',
    enterSplitAmounts: 'أدخل مبلغاً في كل سطر من سطور التقسيم.',
    splitBalanced: 'مجموع سطور التقسيم يساوي مبلغ البنك.',
    splitDifference: 'الفرق: {{amount}}',
    removeSplit: 'إلغاء التقسيم',
    split: 'تقسيم',
    matched: 'تمت المطابقة. لم يُرحَّل أي شيء جديد.',
    badRange: 'يجب أن يكون تاريخ «من» في تاريخ «إلى» أو قبله.',
    from: 'من',
    to: 'إلى',
    searchAria: 'البحث بالاسم أو المذكرة أو الرقم أو المبلغ',
    searchPlaceholder: 'الاسم أو المذكرة أو الرقم أو المبلغ',
    colDate: 'التاريخ',
    colType: 'النوع',
    colRef: 'رقم المرجع',
    noCandidates:
      'لا توجد معاملات للمطابقة في هذه التواريخ. وسّع نطاق التواريخ، أو صنّف السطر بدلاً من ذلك.',
    selectCandidate: 'تحديد {{type}} {{ref}}',
    bankLineAmount: 'سطر البنك {{currency}} {{amount}}',
    selectedAmount: 'المحدد {{currency}} {{amount}}',
    matchDifference: 'الفرق {{amount}}',
    matching: 'جارٍ المطابقة…',
    recordedTransfer: 'سُجّلت كتحويل.',
    transferredFrom: 'محوّل من *',
    transferredTo: 'محوّل إلى *',
    chooseOther: 'اختر الحساب الآخر',
    chooseAccount: 'اختر حساباً',
    amountIn: 'المبلغ بعملة {{currency}} *',
    enterAmountIn: 'أدخل المبلغ بعملة {{currency}}',
    otherStatementHint: 'عند استيراد كشف الحساب الآخر، يُطابَق سطره مع هذا التحويل.',
  },
  ruleDrawer: {
    textOp: {
      contains: 'يحتوي على',
      not_contains: 'لا يحتوي على',
      equals: 'يساوي تماماً',
      starts_with: 'يبدأ بـ',
    },
    amountOp: { equals: 'يساوي', greater_than: 'أكبر من', less_than: 'أقل من' },
    saved: 'حُفظت القاعدة "{{name}}".',
    savedApplies_zero: 'حُفظت القاعدة "{{name}}". لا تنطبق على أي معاملة قيد المراجعة.',
    savedApplies_one: 'حُفظت القاعدة "{{name}}". تنطبق على معاملة واحدة قيد المراجعة.',
    savedApplies_two: 'حُفظت القاعدة "{{name}}". تنطبق على معاملتين قيد المراجعة.',
    savedApplies_few: 'حُفظت القاعدة "{{name}}". تنطبق على {{count}} معاملات قيد المراجعة.',
    savedApplies_many: 'حُفظت القاعدة "{{name}}". تنطبق على {{count}} معاملةً قيد المراجعة.',
    savedApplies_other: 'حُفظت القاعدة "{{name}}". تنطبق على {{count}} معاملة قيد المراجعة.',
    editTitle: 'تعديل القاعدة',
    newTitle: 'قاعدة جديدة',
    description:
      'تصنّف القواعد المعاملات البنكية بالطريقة نفسها في كل مرة. تُطبَّق أول قاعدة منطبقة، بالترتيب الظاهر في صفحة القواعد.',
    ruleName: 'اسم القاعدة *',
    applyTo: 'طبّق هذه القاعدة على المعاملات التي هي',
    inAccount: 'في',
    includeBefore: 'وتستوفي',
    includeAfter: 'الشروط التالية',
    matchAria: 'جميع الشروط أو أيٌّ منها',
    all: 'جميع',
    any: 'أيّاً من',
    conditionField: 'حقل الشرط {{n}}',
    conditionOperator: 'عامل الشرط {{n}}',
    conditionValue: 'قيمة الشرط {{n}}',
    bankText: 'نص البنك',
    amount: 'المبلغ',
    valuePlaceholder: 'مثال: DEWA',
    removeCondition: 'إزالة الشرط {{n}}',
    addCondition: 'إضافة شرط',
    then: 'ثم',
    assignCategory: 'تعيين فئة',
    autoAdd: 'تأكيد المعاملات التي تنطبق عليها هذه القاعدة تلقائياً (إضافة تلقائية)',
    autoAddHint:
      'تتخطى المعاملات الجديدة من الاستيراد التالي مرحلة «قيد المراجعة» وتنتقل مباشرة إلى «مصنّفة» مع الإشارة إلى القاعدة. أما المعاملة التي تطابق معاملة موجودة في الدفاتر فتُترك لك لتطابقها بنفسك.',
    rule: 'القاعدة',
  },
  rules: {
    title: 'القواعد',
    description:
      'تصنّف القواعد المعاملات البنكية نيابةً عنك. تُطبَّق أول قاعدة منطبقة بدءاً من الأعلى.',
    newRule: 'قاعدة جديدة',
    loadFailed: 'تعذّر تحميل القواعد',
    noRules: 'لا توجد قواعد بعد',
    noRulesHint: 'أنشئ قاعدة للمعاملات التي تتكرر كل شهر، مثل DEWA أو du أو الرسوم البنكية.',
    col: {
      priority: 'الأولوية',
      ruleName: 'اسم القاعدة',
      appliedTo: 'تُطبَّق على',
      conditions: 'الشروط',
      settings: 'الإعدادات',
      inForReview: 'قيد المراجعة',
      action: 'الإجراء',
    },
    moveUp: 'نقل {{name}} إلى الأعلى',
    moveDown: 'نقل {{name}} إلى الأسفل',
    autoAdd: 'إضافة تلقائية',
    vatCode: 'ضريبة القيمة المضافة {{code}}',
    deleted: 'حُذفت القاعدة "{{name}}".',
    deleteTitle: 'حذف القاعدة «{{name}}»؟',
    deleteBody:
      'تبقى المعاملات التي صنّفتها كما هي. وتتوقف القاعدة عن اقتراح فئات للمعاملات قيد المراجعة.',
    condText: {
      contains: 'نص البنك يحتوي على «{{value}}»',
      not_contains: 'نص البنك لا يحتوي على «{{value}}»',
      equals: 'نص البنك هو «{{value}}»',
      starts_with: 'نص البنك يبدأ بـ «{{value}}»',
      greater_than: 'نص البنك أكبر من «{{value}}»',
      less_than: 'نص البنك أقل من «{{value}}»',
    },
    condAmount: {
      contains: 'المبلغ يحتوي على {{value}}',
      not_contains: 'المبلغ لا يحتوي على {{value}}',
      equals: 'المبلغ يساوي {{value}}',
      starts_with: 'المبلغ يبدأ بـ {{value}}',
      greater_than: 'المبلغ أكبر من {{value}}',
      less_than: 'المبلغ أقل من {{value}}',
    },
    joinAnd: ' و',
    joinOr: ' أو ',
  },
};
